import { put, take, call } from 'redux-saga/effects';
import {
  getEntityStatus as getEntityStatusAction,
  setEntityStatus,
  setEntityStatusError,
} from '../../reducers/entityStatusSlice';

export default function* entityStatusSaga(api) {
  while (true) {
    const entityStatusAction = yield take(getEntityStatusAction.type);
    const { entityId } = entityStatusAction.payload;
    yield call(getEntityStatus, api, entityId);
  }
}

function* getEntityStatus(api, entityId) {
  try {
    const entityStatusData = yield call(api.getEntityStatus, entityId);
    yield put(setEntityStatus(entityStatusData.data));
  } catch (error) {
    yield put(setEntityStatusError(error.message));
  }
}
